<template>
  <div v-if="value.documentId">
    <label class="document-label d-block">
      Plan de Intervención Firmado:
    </label>
    <div class="row">
      <div class="col-10">{{ value.documentName }}</div>
      <div class="col-2 text-right">
        <ActionButton
          i="fa fa-file-download"
          text="Descargar"
          variant="outline-success"
          @click="$emit('download', value.documentId)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'PlanDocument',
  components: {
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        documentId: null,
        documentName: null,
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.document-label {
  font-size: 0.875rem;
  color: map-get($colors, 'gray-6');
  font-weight: bold;
}
</style>
